import React from 'react'
import { isSignedOrToBeCoSigned } from '../utils';

const EncDateStatus = ({ searchParam, searchValue, noValExistTextNA, data, Data }) => {

    // const EncounterCoSignData = Data?.EncounterCoSignData?.filter(enc => [ true, "true"].includes(enc.isCoSigned));
    const EncounterCoSignData = Data?.EncounterCoSignData;
    const signed = Data?.EncounterCoSignData?.filter(it => [true, "true"].includes(it.isCoSigned));
    const pending = Data?.EncounterCoSignData?.filter(it => [false, "false"].includes(it.isCoSigned));
    return (
        <div className="d-flex align-items-center gap-2">
            <div className="d-flex align-items-center gap-1">
                <p className='heading validate-color'>Encounter Date:</p>
                <p className='text validate-color'>{searchParam?.EncounterDate || noValExistTextNA}</p>
            </div>
            <div className="d-flex align-items-center gap-1">
                <p className='heading validate-color'>Status:</p>
                {(searchValue?.EncounterStatus === 'Signed' || data?.Data?.EncounterStatus === 'Signed') ?
                    (EncounterCoSignData?.length > 0 ? 
                        <></> : 
                        <p className='Paid heading font-m ar-status-clm'>Signed</p>) :
                    searchValue?.EncounterStatus === 'In Progress' ?
                        <p className='Blue-Status heading font-m ar-status-clm'>In Progress</p> :
                        searchValue?.EncounterStatus === 'Ready for Review' ?
                            <p className='In-Review heading font-m ar-status-clm'>Ready for Review</p> :
                            ['Unsigned', 'UnSigned'].includes(searchValue?.EncounterStatus) &&
                            <p className='Not-Signed heading font-m ar-status-clm'>Unsigned</p>}

                    {/* // Co Sign Status Tooltip //// Co Sign ////Sign//// */}
                    {(isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus) && EncounterCoSignData?.length > 0) ?
                    <div className="app_tooltip bottom grossary description claimStatus">
                        {data?.Data?.EncounterStatus === 'Signed' ?
                        <p className='Paid heading font-m ar-status-clm'>{data?.Data?.EncounterStatus}</p> :
                        <p className='pill Transfer-to-Insurance'>{data?.Data?.EncounterStatus}</p>}
                        <p className="tool_tip start-0">
                            <span className='text text-light multi-line-truncate text-wrap overflow-hidden fs-12'>
                                {signed?.length > 0 ? (
                                    <>
                                        Co-signed by: <br />
                                        {signed.map(it => it.ProviderName).join(", ")} <br />
                                        {pending?.length > 0 && (
                                            <>
                                                Pending: <br />
                                                {pending.map(it => it.ProviderName).join(", ")}
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        To be co-signed by: <br />
                                        {pending.map(it => it.ProviderName).join(", ")}
                                    </>
                                )}
                            </span>
                        </p>
                    </div> : <></>}
            </div>
        </div>
    )
}

export default EncDateStatus